module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Bold.d80f3f53.eot";